export default "__VITE_ASSET__BT7C6ycJ__"